import React from 'react';
import { useRequireAuth } from '../hooks/auth/useRequireAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Component that protects routes by checking for authentication cookies.
 * Redirects to /login if user is not authenticated.
 * Returns null during redirect to prevent flickering.
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const isAuthenticated = useRequireAuth();

  if (!isAuthenticated) {
    return null;
  }

  return <>{children}</>;
};
